<template>
    <card>
            <base-input
                    v-model="timecondition.name"
                    label="Name"
                    required
                    :ref="'name-' + timecondition.id"
                    :name="'name-' + timecondition.id"
                    v-validate="'required|min:3|max:50'"
                    @input="handleNameInputChange(timecondition.id,$event)"
                    :error="getError('name-' + timecondition.id)"
            ></base-input>
            <hr>
            <div class="row">
                <label class="col-md-4 col-lg-3 col-xl-2">Schedule
                    <span>*</span>
                </label>
                <div class="col-md-8 col-lg-9 col-xl-10">
                    <base-radio inline name="always" v-model="schedule">
                        Always
                    </base-radio>
                    <base-radio inline name="custom" v-model="schedule">
                        Custom
                    </base-radio>
                    <hr>
                    <base-radio inline name="daily" v-if="schedule === 'custom'" v-model="scheduleCustom">
                        Daily
                    </base-radio>
                    <base-radio inline name="weekly" v-if="schedule === 'custom'" v-model="scheduleCustom">
                        Weekly
                    </base-radio>
                    <base-radio inline name="dates" v-if="schedule === 'custom'" v-model="scheduleCustom">
                        Dates
                    </base-radio>
                </div>
            </div>
            <div class="row mt-3" v-if="schedule === 'custom'">
                <div v-if="scheduleCustom === 'daily'" class="col-12 col-lg-9 offset-lg-3 col-xl-10 offset-xl-2">
                    <timecondition-times :initial-value="customSchedule.daily.data"
                                         v-on:update="handleDailyUpdate($event)"></timecondition-times>


                </div>
                <div v-if="scheduleCustom === 'weekly'" class="col-12 col-lg-9 offset-lg-3 col-xl-10 offset-xl-2">
                    <div class="form-row mt-1" v-for="(dayOfWeek,index) in customSchedule.weekly.data">
                        <base-checkbox class="col-4 col-sm-4 col-md-3 col-lg-3"
                                       v-model="customSchedule.weekly.data[index].enabled">
                            {{ moment().day(index).format('dddd') }}
                        </base-checkbox>
                        <timecondition-times v-if="customSchedule.weekly.data[index].enabled" class="col-8 col-sm-8 col-md-9 col-lg-9"
                                             :initial-value="customSchedule.weekly.data[index].data"
                                             v-on:update="handleWeeklyUpdate($event,index)"></timecondition-times>
                    </div>
                </div>
                <div v-if="scheduleCustom === 'dates'" class="col-12 col-lg-9 offset-lg-3 col-xl-10 offset-xl-2"
                     style="padding-right:0;">
                    <timecondition-dates :initial-value="customSchedule.dates.data"
                                         v-on:update="handleDatesUpdate($event)"></timecondition-dates>
                </div>
            </div>
            <div slot="footer">
                <div class="row">
                    <div class="col">
                        <base-button class="left" :loading="saving" :disabled="!dirty"
                                     @click="save" type="primary">
                            Save
                        </base-button>

                        <base-button icon @click="remove" type="danger" :loading="removing"
                                     class="right">
                            <font-awesome-icon v-if="!removing" :icon="['fal','trash']"></font-awesome-icon>
                        </base-button>

                    </div>
                </div>

            </div>
        </card>
</template>

<script>
    import swal from 'sweetalert2';
    import TimeconditionTimes from "./TimeconditionTimes";
    import TimeconditionDates from "./TimeconditionDates";


    export default {
        name: "TimeconditionCard",
        components: {TimeconditionDates, TimeconditionTimes},
        props: {
            initialTimecondition: Object,
        },
        data() {
            return {
                timecondition: this.initialTimecondition,
                dirty: false,
                saving: false,
                removing: false,
                customSchedule: {
                    daily: {
                        enabled: true,
                        data: [],
                    },
                    weekly: {
                        enabled: true,
                        data: [
                            {
                                enabled: false,
                                data: []
                            },
                            {
                                enabled: false,
                                data: []
                            },
                            {
                                enabled: false,
                                data: []
                            },
                            {
                                enabled: false,
                                data: []
                            },
                            {
                                enabled: false,
                                data: []
                            },
                            {
                                enabled: false,
                                data: []
                            },
                            {
                                enabled: false,
                                data: []
                            },
                        ],

                    },
                    dates: {
                        enabled: true,
                        data: [],
                    },
                },
                schedule: 'custom',
                scheduleCustom: 'daily',
            }
        },

        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            validate() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.save()
                    }
                })
            },
            save() {
                this.saving = true;
                let data = {
                    name: this.timecondition.name,
                    timecondition: {
                        type: this.schedule,
                        data: this.customSchedule
                    }
                };
                let id = this.timecondition.id;

                this.$store.dispatch('timecondition/save', {data, id}).then(() => {
                    this.saving = false;
                    this.dirty = false;
                    this.$emit('saved');
                    this.$notify({
                        verticalAlign: 'bottom',
                        horizontalAlign: 'right',
                        message: 'Your timecondition: ' + data.name + ' was saved!',
                        type: "success",
                        icon: "fal fa-save",
                        title: "Saved!"
                    });
                }).catch(() => {
                    this.saving = false;
                    this.$notify({
                        position: "bottom-right",
                        message: 'Your timecondition: ' + data.name + ' failed to save!',
                        type: "error",
                        icon: "fal fa-times",
                        title: "Error!"
                    });
                });
            },
            handleNameInputChange(id, value) {
                this.timecondition.name = value.replace(/[#,."'/\\`~ :;}{|$&%^?+*]/g, '');
                this.dirty = true;
            },
            remove() {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to restore this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.removing = true;
                        let id = this.timecondition.id;
                        this.$store.dispatch('timecondition/remove', {id}).then(() => {
                            this.$notify({
                                verticalAlign: 'bottom',
                                horizontalAlign: 'right',
                                message: 'Your timecondition was removed!',
                                type: "success",
                                icon: "fal fa-trash",
                                title: "Removed!"
                            });

                            this.dirty = false;
                            this.saving = false;
                            this.removing = false;
                            this.$emit('removed');
                        });
                    }
                });
            },
            handleWeeklyUpdate($event, index) {
                this.customSchedule.weekly.data[index].data = $event;
                this.customSchedule.weekly.enabled = true;
                this.scheduleCustom = 'weekly';
            },
            handleDailyUpdate($event) {
                this.customSchedule.daily.data = $event;
                this.customSchedule.daily.enabled = true;
                this.scheduleCustom = 'daily';
            },
            handleDatesUpdate($event) {
                this.customSchedule.dates.data = $event;
                this.customSchedule.dates.enabled = true;
                this.scheduleCustom = 'dates';
            }
        },
        mounted() {
            this.timecondition = this.initialTimecondition;
            this.customSchedule = this.timecondition.timecondition.data;
            this.schedule = this.timecondition.timecondition.type;
            this.scheduleCustom = this.customSchedule.daily.enabled ? 'daily' : this.customSchedule.weekly.enabled ? 'weekly' : this.customSchedule.dates.enabled ? 'dates' : 'daily';
        },
        watch: {
            customSchedule: {
                handler(value) {
                    this.dirty = true;
                },
                deep: true
            },
            timecondition: {
                handler(value) {
                }
            },
            scheduleCustom: {
                handler(value) {
                    if (value === 'daily') {
                        this.customSchedule.daily.enabled = true;
                        this.customSchedule.weekly.enabled = false;
                        this.customSchedule.dates.enabled = false;
                    }
                    if (value === 'weekly') {
                        this.customSchedule.daily.enabled = false;
                        this.customSchedule.weekly.enabled = true;
                        this.customSchedule.dates.enabled = false;
                    }
                    if (value === 'dates') {
                        this.customSchedule.daily.enabled = false;
                        this.customSchedule.weekly.enabled = false;
                        this.customSchedule.dates.enabled = true;
                    }
                }
            }
        }
    }
</script>

<style>
    span.el-range-separator {
        min-width: 27px !important;
    }
</style>